import { render, staticRenderFns } from "./rename-bucket.html?vue&type=template&id=9883c11a&scoped=true&"
import script from "./rename-bucket.js?vue&type=script&lang=js&"
export * from "./rename-bucket.js?vue&type=script&lang=js&"
import style0 from "./rename-bucket.scss?vue&type=style&index=0&id=9883c11a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9883c11a",
  null
  
)

export default component.exports